import { setEditorHandler } from 'react-error-overlay';

setEditorHandler(() => {
  // Do nothing
  return null;
});
